import { Link } from 'react-router-dom'
import { Box, Button, Container, Typography } from '@mui/material'

const rootStyle = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%)',
  py: 4
}

export function StripeCancelPage() {
  return (
    <Box sx={rootStyle}>
      <Container maxWidth="sm">
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h5" sx={{ fontWeight: 700, color: '#e65100', mb: 2 }}>
            Paiement annulé
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 3 }}>
            Vous avez annulé le paiement. Aucun prélèvement n'a été effectué.
          </Typography>
          <Button component={Link} to="/team/add" variant="contained" size="large" sx={{ mr: 1 }}>
            Réessayer
          </Button>
          <Button component={Link} to="/dashboard" variant="outlined" size="large">
            Tableau de bord
          </Button>
        </Box>
      </Container>
    </Box>
  )
}
